import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OfferDetailsAll from "../../components/Marketplace/OfferDetails/OfferDetailsAll";
import { isOfferOwner } from "../../api/offers";
import { getRole } from "../../api/users";

export default function OfferDetailsPage() {
    const { offerId } = useParams<{ offerId: string }>();
    const [isOwner, setIsOwner] = useState<boolean>(false);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(true);
    const { id } = useParams();

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                if (id) {
                    const roleData = await getRole();
                    setIsAdmin(roleData.role === "admin" || roleData.role === "superadmin");
                }
            } catch (error) {
                console.error("Error checking owner:", error);
            } finally {
                setLoading(false);
            }
        };
        const checkOwner = async () => {
            try {
                if (id) {
                    const owner = await isOfferOwner(Number(id));
                    setIsOwner(owner);
                }
            } catch (error) {
                console.error("Error checking owner:", error);
            } finally {
                setLoading(false);
            }
        };
        checkAdmin();
        checkOwner();

    }, [offerId]);

    if (loading) {
        return <p className="text-center mt-10">Loading...</p>;
    }

    return (
        <>
            {
                isOwner ? (
                    <OfferDetailsAll mode="owner" />
                ) :
                    isAdmin ? (
                        <OfferDetailsAll mode="admin" />
                    ) :
                        <OfferDetailsAll mode="user" />

            }
        </>
    );
}
